<sew-ws-content-wrapper>
    <h2 class="typo-ws-h2" [innerHTML]="header"></h2>
    <div class="grid grid--three-columns">
        @for (article of articles; track article) {
            <blog-post
                (postClicked)="onPostClicked($event)"
                (tagClicked)="onTagClicked($event)"
                [post]="article"
                [size]="'m'"
                slot="teaser-item"
                class="no-padding"
            ></blog-post>
        }
    </div>
</sew-ws-content-wrapper>
